import { MutationTree } from 'vuex'
import ProductState from './ProductState'
import * as types from './mutation-types'

const mutations: MutationTree <ProductState> = {
  [types.PRODUCT_ADD_TO_CACHED_MULTIPLE] (state, payload) {
    if (payload.products) {
      payload.products.forEach((product: any) => {
        state.cached[product.pseudoId] = product
        state.productById[product.productId] = product
      });
    }
  },
  [types.PRODUCT_LIST_UPDATED](state, payload) {
    state.list.items = payload.products
    state.list.total = payload.total
  }
}
export default mutations;